import { render } from "./OffcanvasForm.vue?vue&type=template&id=3c3c00af"
import script from "./OffcanvasForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__